import React, { useState, useEffect } from "react";
import axios from "axios";
import UnblockUserModal from "./unblockUserModal/UnblockUserModal";
import styles from "./settingsBlockedUsers.module.css";

const apiUrl = process.env.REACT_APP_URL;

const SettingsBlockedUsers = ({ currUsername }) => {
  /* This component shows the list of users blocked by the usee. The user can unblock a user. */

  const [blockedUsers, setBlockedUsers] = useState([]);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  /**
   * Get the list of users blocked by the user, from the database
   */
  useEffect(() => {
    const getBlockedUsers = async () => {
      try {
        const res = await axios.get(
          `${apiUrl}/relationships/blocked/${currUsername}`,
          {
            withCredentials: true,
          }
        );

        if (res.status === 200 && res.data.success) {
          setBlockedUsers(res.data.result);
        } else {
          console.error("Error getting the list of blocked users");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error("User is not logged in");
        } else {
          console.error("Error getting the list of blocked users", error);
        }
      }
    };

    getBlockedUsers();
  }, [currUsername]);

  /**
   * Show the confirmation modal to allow the user to unblock a user
   * @param {*} username - the username of the user to unblock
   */
  const handleUnblockUser = (username) => {
    setShowUnblockModal(true);
    setSelectedUser(username);
  };

  /**
   * Close the confirmation modal
   */
  const handleCloseModal = () => {
    setShowUnblockModal(false);
    setSelectedUser(null);
  };

  /**
   * Unblock a user (selectedUser)
   */
  const handleConfirmUnblock = async () => {
    if (!selectedUser) return;

    try {
      const res = await axios.put(
        `${apiUrl}/relationships/block/${currUsername}/${selectedUser}`,
        { blockStatus: false },
        {
          withCredentials: true,
        }
      );

      if (res.status === 200 && res.data.success) {
        setBlockedUsers((prevUsers) =>
          prevUsers.filter((user) => user.blockedUser !== selectedUser)
        );
        setShowUnblockModal(false);
        setSelectedUser(null);
      } else {
        console.error("Error unblocking user");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.error("User is not logged in");
      } else {
        console.error("Error unblocking user", error);
      }

      setShowUnblockModal(false);
      setSelectedUser(null);
    }
  };

  return (
    <div className={styles.blockedUsersContainer}>
      <p className={styles.blockedUsersHeader}>
        This is a list of users that are currently blocked by you. Click on a
        user to unblock them.
      </p>
      {blockedUsers.map((user, idx) => (
        <div
          key={idx}
          className={styles.blockedUserItem}
          onClick={() => handleUnblockUser(user.blockedUser)}
        >
          {user.blockedUser}
          <button className={styles.unblockButton}>Unblock</button>
        </div>
      ))}
      <UnblockUserModal
        show={showUnblockModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmUnblock}
        unblockedUsername={selectedUser}
      />
    </div>
  );
};

export default SettingsBlockedUsers;
